export const WIT_API_CONFIG = {
  classifyUrl: 'https://nosqlstore.web.app/api/wit/classify',
  trainUrl: 'https://nosqlstore.web.app/api/wit/train',
  intentsUrl: 'https://nosqlstore.web.app/api/wit/intents',
  entitiesUrl: 'https://nosqlstore.web.app/api/wit/entities',
  auditListUrl: 'https://nosqlstore.web.app/api/wit/audit',
  auditReviewUrl: 'https://nosqlstore.web.app/api/wit/audit/review',
};
